export const MODAL_ID = {
  DEFAULT: 'shop_details',
  PRODUCT_CONFIGURATION: 'product_configuration',
  SHOP_INFO: 'shop_info',
  SHOP_REVIEW: 'shop_reviews',
  SHOP_SEARCH: 'shop_search',
  SHOP_SECTION: 'shop_section',
};
